import React, { FunctionComponent } from 'react';

import { CommonError } from 'src/components/common-error';
import { i18n } from 'src/i18n';
import { owlImageProps } from 'src/resources/images';
import { DataLayerEcomErrors } from 'src/types/data-layer-event-object';

export const PageRestrictedPurchase: FunctionComponent = () => (
  <CommonError
    title={i18n.page.error.restrictedPurchase.title}
    subtitles={i18n.page.error.restrictedPurchase.subtitle}
    image={owlImageProps}
    dataLayerErrorMessage={DataLayerEcomErrors.RESTRICTED_PURCHASE_ERROR}
  />
);
